export default class InlineIconsModule {
  constructor(element) {
    this.el = element;
    this.icons = Array.from(this.el.querySelectorAll('.icon-item-wrapper > div'));
    this.observer = null;
    this.init();
  }

  init() {
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0
    });

    this.icons.forEach((icon, i) => {
      icon.dataset.delayIndex = i;
      this.observer.observe(icon);
    });
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const icon = entry.target;
        const i    = Number(icon.dataset.delayIndex);

        icon.style.transition = `all 0.5s ${i * 0.1}s`;
        icon.classList.add('animate-in');

        this.observer.unobserve(icon);
      }
    });
  }
}
